(() => {
  angular.module('app').component('apiKeysEntry', {
    template: `<new-front-container path="ctrl.path"
        application="ctrl.application" params="ctrl.params"
        on-state-changed="ctrl.onStateChanged(params)"></new-front-container>`,
    controller: Controller,
    controllerAs: 'ctrl',
    // customerId comes from each role's router: Manager has it in its session.
    bindings: { $transition$: '<', customerId: '<' },
  });
  Controller.$inject = ['NativeAppIntegration', '$state'];
  function Controller(integration, $state) {
    const vm = this;
    integration.syncState('api-keys', vm, $state);
    vm.$onInit = () => {
      vm.params = integration.params('api-keys', vm.$transition$.params());
      vm.application = { appKey: 'api-keys', customerId: vm.customerId };
      // The selected key is part of the React route.
      vm.path = `/customers/${encodeURIComponent(vm.customerId)}/apps/api-keys` +
        (vm.params.apiKeyId ? `/${encodeURIComponent(vm.params.apiKeyId)}` : '');
    };
  }
})();
